import React from 'react';
import { Input } from '@nextui-org/react';

interface Props {
    status: string[];
    cohort: string[];
    condition: string[];
    q: string;
    onChange: (key: string, value: string | string[]) => void;
}

const Filters: React.FC<Props> = ({ status, cohort, condition, q, onChange }) => {

    // Simplistic implementations for filters as native HTML elements to avoid beta bugs and complexities.
    const handleStatusToggle = (s: string) => {
        const next = new Set(status);
        if (next.has(s)) next.delete(s);
        else next.add(s);
        onChange('status', Array.from(next));
    };

    return (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem', padding: '1rem', background: '#f9f9f9', borderRadius: '8px', border: '1px solid #eaeaea' }}>

             {/* Cohort (Native Select for MVP simplicity) */}
             <div>
                 <label style={{ display: 'block', fontSize: '12px', marginBottom: '4px', fontWeight: 'bold' }}>Cohort</label>
                 <select
                    multiple
                    value={cohort}
                    onChange={e => onChange('cohort', Array.from(e.target.selectedOptions, option => option.value))}
                    style={{ fontSize: '13px', padding: '4px', borderRadius: '4px', border: '1px solid #ccc', minWidth: '120px' }}
                >
                     <option value="pilot_2026_q2">pilot_2026_q2</option>
                     <option value="pilot_2026_q3">pilot_2026_q3</option>
                 </select>
             </div>

             {/* Condition */}
             <div>
                 <label style={{ display: 'block', fontSize: '12px', marginBottom: '4px', fontWeight: 'bold' }}>Condition</label>
                 <select
                    multiple
                    value={condition}
                    onChange={e => onChange('condition', Array.from(e.target.selectedOptions, option => option.value))}
                    style={{ fontSize: '13px', padding: '4px', borderRadius: '4px', border: '1px solid #ccc', minWidth: '120px' }}
                >
                     <option value="socratic_only">socratic_only</option>
                     <option value="hybrid">hybrid</option>
                     <option value="mentor_only">mentor_only</option>
                 </select>
             </div>

             {/* Status Chips */}
             <div>
                 <label style={{ display: 'block', fontSize: '12px', marginBottom: '4px', fontWeight: 'bold' }}>Status</label>
                 <div style={{ display: 'flex', gap: '4px' }}>
                     {['completed', 'abandoned', 'interrupted', 'in_progress'].map(s => (
                         <button
                            key={s}
                            onClick={() => handleStatusToggle(s)}
                            style={{
                                padding: '4px 8px',
                                fontSize: '12px',
                                borderRadius: '12px',
                                border: '1px solid #ccc',
                                cursor: 'pointer',
                                background: status.includes(s) ? '#0070f3' : '#fff',
                                color: status.includes(s) ? '#fff' : '#333'
                            }}
                         >
                             {s}
                         </button>
                     ))}
                 </div>
             </div>

             {/* Date Range (Simplified) */}
             <div>
                 <label style={{ display: 'block', fontSize: '12px', marginBottom: '4px', fontWeight: 'bold' }}>Date Range</label>
                 <select
                    onChange={e => {
                        // Normally this would parse to before/after dates, sending pseudo value for now
                        onChange('date_range', e.target.value);
                    }}
                    style={{ fontSize: '13px', padding: '4px', borderRadius: '4px', border: '1px solid #ccc' }}
                >
                    <option value="">All</option>
                    <option value="last_7d">Last 7d</option>
                    <option value="last_30d">Last 30d</option>
                 </select>
             </div>

             {/* Search */}
             <div style={{ flexGrow: 1, minWidth: '200px' }}>
                 <label style={{ display: 'block', fontSize: '12px', marginBottom: '4px', fontWeight: 'bold' }}>Search</label>
                 <Input
                    aria-label="Search"
                    placeholder="Participant ID or turns text..."
                    size="sm"
                    fullWidth
                    value={q}
                    onChange={(e) => onChange('q', e.target.value)}
                 />
             </div>

        </div>
    );
};

export default Filters;